// extracted by mini-css-extract-plugin
export default {"welcomePageContainer":"SuccessPage_welcomePageContainer__8soFp","box":"SuccessPage_box__MSv7T","yellow":"SuccessPage_yellow__OfJT5"};